<div class="slot-card-wrapper" [ngClass]="[bgCardClass, borderClass]" *ngIf="teamShiftDetail">
  <div class="team-header-wrappper">
    <span class="title-heading">{{teamShiftDetail.firstName}} {{teamShiftDetail.lastName}}</span>
    <div class="timestr">
      <ng-container *ngFor="let shiftMemberSchedule of teamShiftDetail?.shiftMemberSchedules; let isLast = last;">
        <ng-container  *ngIf="shiftMemberSchedule?.leaveType">
          <span class="text red-text">{{shiftMemberSchedule?.leaveType}}
            ({{shiftMemberSchedule?.startTimeStr}} - {{shiftMemberSchedule?.endTimeStr}})</span>
          </ng-container>
        <span class="text" *ngIf="shiftMemberSchedule?.startTimeStr && shiftMemberSchedule?.endTimeStr && !shiftMemberSchedule?.leaveType">{{shiftMemberSchedule?.startTimeStr}} - {{shiftMemberSchedule?.endTimeStr}}</span>
        <span *ngIf="(shiftMemberSchedule?.startTimeStr && shiftMemberSchedule?.endTimeStr) && !isLast">, </span>
      </ng-container>
    </div>
    <div class="text" *ngIf="setNotAvailableFlag(teamShiftDetail.shiftMemberSchedules)">
      <span>Shift Unavailable</span>
    </div>
  </div>
</div>